import { cloneDeep } from 'lodash';

import { Action } from '../actions';
import {
    FETCH_INFO_BLOCK_DATA,
    FETCH_NEXT_INFO_BLOCK_NEWS_ITEM,
    SET_HEADER_WALLET_INFO,
    SET_INFO_BLOCK_NEWS_ERROR,
    SET_UNAUTHORIZED_HEADER_DATA,
    SET_USER_ACCOUNTS_INFO_FETCH_ERROR,
    UPDATE_HEADER_INFO,
    UPDATE_INFO_BLOCK_DATA,
    UPDATE_INFO_BLOCK_NEWS_DATA,
    UPDATE_USER_ACCOUNTS_INFO
} from '../actions/header';
import { ReducerCustom } from '../service/Redux/Redux';
import { CampaignType } from '../typings/domain';
import { GdMenuItem } from '../typings/graphql-grid';
import {
    HeaderInfoBlockNewsData,
    HeaderInfoBlockNewsItemData
} from '../typings/header';
import { HeaderState, State } from '../typings/state';

export interface HeaderInitialData {
    availableCampaignsTypes?: CampaignType[];
    role?: string;
}

function updateInfoBlockNewsData(
    newsState: HeaderInfoBlockNewsData,
    data: HeaderInfoBlockNewsItemData
): HeaderInfoBlockNewsData {
    const newHeaderState = cloneDeep(newsState);

    newHeaderState.items.push(data);
    newHeaderState.itemsQueue.shift();

    return newHeaderState;
}

export const getHeader = (
    initData: HeaderInitialData
): ReducerCustom<HeaderState> => {
    const headerInitialState: HeaderState = {
        isInfoBlockLoading: true,
        infoBlockData: {
            news: {
                items: [],
                itemsQueue: []
            },
            isInfoBlockAvailable: false
        },
        ...initData
    };

    return (
        state: HeaderState = headerInitialState,
        action: Action,
        fullState: State
    ): HeaderState => {
        switch (action.type) {
            case UPDATE_INFO_BLOCK_DATA:
                return {
                    ...state,
                    infoBlockData: action.newsData,
                    isInfoBlockLoading: false
                };
            case UPDATE_INFO_BLOCK_NEWS_DATA:
                return {
                    ...state,
                    infoBlockData: {
                        ...state.infoBlockData,
                        news: updateInfoBlockNewsData(
                            state.infoBlockData.news,
                            action.newsDataItem
                        )
                    },
                    isInfoBlockLoading: false
                };
            case FETCH_NEXT_INFO_BLOCK_NEWS_ITEM:
                return {
                    ...state,
                    isInfoBlockLoading: true,
                    infoBlockData: {
                        ...state.infoBlockData,
                        news: {
                            ...state.infoBlockData.news,
                            error: undefined
                        }
                    }
                };
            case FETCH_INFO_BLOCK_DATA:
                return {
                    ...state,
                    infoBlockData: {
                        ...state.infoBlockData,
                        news: {
                            ...state.infoBlockData.news,
                            error: undefined
                        }
                    }
                };
            case SET_INFO_BLOCK_NEWS_ERROR:
                return {
                    ...state,
                    infoBlockData: {
                        ...state.infoBlockData,
                        news: {
                            ...state.infoBlockData.news,
                            error: action.error
                        }
                    },
                    isInfoBlockLoading: false
                };
            case UPDATE_USER_ACCOUNTS_INFO:
                return {
                    ...state,
                    userAccountsInfo: action.accountsInfo
                };

            case SET_USER_ACCOUNTS_INFO_FETCH_ERROR:
                return {
                    ...state,
                    userAccountsInfo: {
                        error: true
                    }
                };
            case UPDATE_HEADER_INFO:
                return {
                    ...action.data,
                    ...state
                };
            case SET_UNAUTHORIZED_HEADER_DATA:
                return {
                    ...state,
                    allowedMenuItems: [
                        GdMenuItem.WORDSTAT,
                        GdMenuItem.ADVANCED_FORECAST
                    ]
                };
            case SET_HEADER_WALLET_INFO:
                return {
                    ...state,
                    wallet: action.wallet
                };
            default:
                return state;
        }
    };
};
